module.exports = __webpack_public_path__ + "static/media/icon-master.282f0f8b.png";